import React from 'react';
import styles from './responsive-video-info.scss';
import VideoMetadata from '../../../components/video-metadata/video-metadata';
import PurchaseButton, { SKINS } from '../purchase-button/purchase-button';
import { VideoRoles } from '../../../components/video-roles/video-roles';
import { VideoPoster } from '../../../components/video-poster/video-poster';

function ResponsiveVideoInfo({
  video,
  channel,
  currentSiteUser,
  onPurchaseClick,
}) {
  const { cast, crew, posterUrl } = video;
  const renderPurchaseButton = (className, skin) => (
    <PurchaseButton
      video={video}
      channel={channel}
      currentSiteUser={currentSiteUser}
      onClick={onPurchaseClick}
      skin={skin}
      className={className}
    />
  );

  return (
    <div className={styles.container}>
      {renderPurchaseButton(styles.buttonOnTop)}
      <div className={styles.flexContainer}>
        <div className={styles.content}>
          <div className={styles.title}>{video.title}</div>
          {renderPurchaseButton(styles.buttonInDescription, SKINS.TRANSPARENT)}
          <VideoMetadata video={video} className={styles.metaInfo} />
          <div className={styles.description}>{video.description}</div>
          <VideoRoles type="mobileCast" items={cast} className={styles.roles} />
          <VideoRoles type="mobileCrew" items={crew} className={styles.roles} />
        </div>
        <VideoPoster posterUrl={posterUrl} className={styles.poster} />
      </div>
    </div>
  );
}

export default ResponsiveVideoInfo;
